import { useAtom } from 'jotai'
import { atomWithStorage, createJSONStorage } from 'jotai/utils'

export type CurrentBooking = {
    bookingIds?: number[]
    visitGroupId?: string
    branchId: number
}

const CURRENT_BOOKING_STORAGE_KEY = '@barbershop/customer/current-booking'

const currentBookingStorage = createJSONStorage<CurrentBooking | undefined>(() => localStorage)

const currentBookingAtom = atomWithStorage<CurrentBooking | undefined>(
    CURRENT_BOOKING_STORAGE_KEY,
    undefined,
    currentBookingStorage,
    {
        getOnInit: true,
    }
)

export const useCurrentBooking = () => {
    const [currentBooking, setCurrentBooking] = useAtom(currentBookingAtom)

    return {
        currentBookingBranchId: currentBooking?.branchId,
        currentBookingVisitGroupId: currentBooking?.visitGroupId,
        currentBookingIds: currentBooking?.bookingIds,
        setCurrentBooking,
    }
}
